__turbopack_context__.v({
  "bannerCell": "MxfOQW_bannerCell",
  "cell": "MxfOQW_cell",
});
